<template>
    <div class="success-view">
        <img
            class="success-logo"
            :src="logoB64.length ? logoB64 : require('@/assets/ARGOstqr_Digital_logo_banner.png')"
        />
        <MultiVideoProjectSuccess v-if="qrcodeObject.type === QrCodeTypes.MULTI_VIDEO" />
        <StandardProjectSuccess v-if="qrcodeObject.type === QrCodeTypes.ONE_SHOT" :arEnabled="qrcodeObject.arEnabled" />
        <div class="view-footer">
            <RGPDLink />
            <GcuLink class="gcu-link" v-if="$t('general.GCU').length" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import GcuLink from "@/components/gcuLink.vue";
import RGPDLink from "@/components/RGPDLink.vue";
import colors from "@/styles/colors";
import { mapState } from "vuex";
import { State } from "@/store";

import { QrCodeTypes } from "@/models/QrCodeObject";

import MultiVideoProjectSuccess from "./success/MultiVideoProjectSuccess.vue";
import StandardProjectSuccess from "./success/StandardProjectSuccess.vue";

export default defineComponent({
    name: "Success",
    components: {
        RGPDLink,
        GcuLink,
        MultiVideoProjectSuccess,
        StandardProjectSuccess
    },
    data() {
        return {
            colors,
            QrCodeTypes: QrCodeTypes
        };
    },
    computed: {
        ...mapState({
            logoB64: (state: State) => state.qrcode.logoB64,
            qrcodeObject: (state: State) => state.qrcode.qrcodeObject
        })
    },
    methods: {
        goAr() {
            let permissionPromise;

            if (typeof DeviceMotionEvent.requestPermission === "function") {
                permissionPromise = DeviceMotionEvent.requestPermission();
            } else {
                permissionPromise = Promise.resolve("granted");
            }

            permissionPromise.then(response => {
                if (response === "granted") {
                    this.$router.replace("AR");
                } else {
                    this.$router.replace("/");
                }
            });
        }
    }
});
</script>

<style scoped>
.success-logo {
    width: 150px;
    margin-top: 30px;
    margin-bottom: 60px;
}

.success-view {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    color: var(--secondary);
}

.view-footer {
    margin-top: 20px;
    padding-bottom: 20px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}
</style>
